export const environment = {
  production: true,
  GRAPHQL_URL: 'https://radar-api.voyagu.app/portal/graphql',
  GRAPHQL_PROTECTED_URL: 'https://radar-api.voyagu.app/a-portal/graphql',
  GRAPHQL_SCHEMA_URL: 'https://radar-api.voyagu.app/portal/schema',
  BUILD_QUERY_KEY: '6a004d54ad43#14',
  STRIPE_PUBLIC_KEY: 'pk_live_51PY5afCT8QD2jpZcIY2gn3ompPvRsTRc1tIc941Xlov6kfYsIQIPeMw3TZ4gsOXVmeCFTU8ATHJPzK8b1FMKs9yf00LF7Ifl7B',
  CLOUDFRONT_API: 'https://d32xlaew8n9fq7.cloudfront.net/production/portal/graphql',
  TRACKING_URL: 'https://tr.businessclassconsolidator.com',
  AWS_PROJECT_REGION: 'eu-west-2',
  AWS_COGNITO_REGION: 'eu-west-2',
  AWS_USER_POOLS_ID: 'eu-west-2_RlqmhW89a',
  AWS_USER_POOLS_WEB_CLIENT_ID: '30me7ppb3ae597lud0rra11dgd',
  OAUTH_DOMAIN: 'production-portal.auth.eu-west-2.amazoncognito.com',
  AMPLIFY_REDIRECT_SIGN_IN: 'https://q.bcconsolidator.com/login',
  AMPLIFY_REDIRECT_SIGN_OUT: 'https://q.bcconsolidator.com/logout',
  GOOGLE_FLIGHTS_URL: 'https://eba3q2xrqud2t5wv5statubp640ehxct.lambda-url.eu-west-2.on.aws/api/google_flights/search',
};